import { IButtonStyles } from '@fluentui/react';
import { memoizeFunction } from '@fluentui/react/lib/Utilities';

import { baseFabricFocusAfterSelector, baseFabricFocusSelector } from '@1js/acui-common';

import { ribbonModeStylingConstantsMLR } from '../../ribbonStylingConstants';

export const getGroupLauncherStyles = memoizeFunction(
  (): IButtonStyles => {
    return {
      root: {
        height: 12,
        width: 12,
        padding: 0,
        marginRight: -ribbonModeStylingConstantsMLR.groupDividerPadding.left,
        position: 'relative',
        alignSelf: 'flex-end',
        justifyContent: 'center',
      },
      icon: {
        // Adding !important because the display atrribute should not be overriden for the launcher to show up
        display: 'flex !important',
        height: 8,
        width: 8,
      },
      rootFocused: {
        [baseFabricFocusSelector]: {
          borderColor: 'transparent',
        },
        [baseFabricFocusAfterSelector]: {
          top: -3,
          left: -3,
          right: -3,
        },
      },
    };
  }
);
